import React, { useEffect, useState } from "react";
import { getIglooLocks } from "../../Api Methods/Api";
import { useDispatch, useSelector } from "react-redux";
import { useScrollTrigger } from "@mui/material";
import { Await } from "react-router-dom";
import PadlocksList from "./padlocksList";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import Stats2 from "../../components/UI/Stats/Stats2";
import mixpanel from "mixpanel-browser";

const Padlocks = () => {

    const dispatch = useDispatch();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const apiData = {
        token,
        client
    }

    const [locks, setPadlocks] = useState([])
    const [unlinkedLocks, setUnlinkedPadlocks] = useState([])
    const [locksOnActiveSites, setLocksOnActiveSites] = useState(0)
    const [billableLocks, setBillableLocks] = useState(0)
    const [nonBillableLocks, setNonBillableLocks] = useState(0)
    const [criticalLocks, setCriticalLocks] = useState([])
    const [warningLocks, setWarningLocks] = useState([])
    const [healthyLocks, setHealthyLocks] = useState([])
    const [update, setUpdate] = useState(0)
    const filtering = ""
    const [isLoading, setIsLoading] = useState(true)

    //Pull data on mount
    useEffect(() => {
        const HandleGetLocks = async () => {
            const response = await getIglooLocks(apiData, dispatch);
            setPadlocks(response.data[0])
            setLocksOnActiveSites(response.data[0].filter(lock => lock.active == 1))
            setBillableLocks(response.data[0].filter(lock => lock.billable == 1))
            setNonBillableLocks(response.data[0].filter(lock => lock.billable == 0))
            setUnlinkedPadlocks(response.data[0].filter(lock => lock.pinName == "Not Linked"))
            setCriticalLocks(response.data[0].filter(lock => lock.battery <= 5))
            setWarningLocks(response.data[0].filter(lock => lock.battery > 5 && lock.battery < 20))
            setHealthyLocks(response.data[0].filter(lock => lock.battery >= 20))

            setIsLoading(false)
        }

        HandleGetLocks();
        mixpanel.track("Padlocks tab visited", {
            user: localStorage.getItem('email')
        })
    }, [update])



    return (
        <Await resolve={locks}>
                <div style={{ width: "100%" }}>
                    <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                        <Stats2 
                            title={"Total padlocks"} 
                            value={locks.length}  
                            isLoadingStats={isLoading} 
                            isStatic={true} 
                        />
                        <Stats2 
                            title={"Critical (<5% battery)"} 
                            value={criticalLocks.length}  
                            isLoadingStats={isLoading} 
                            isStatic={true} 
                        />
                        <Stats2 
                            title={"Warning (<20% battery)"} 
                            value={warningLocks.length}  
                            isLoadingStats={isLoading} 
                            isStatic={true} 
                        />
                        <Stats2 
                            title={"Healthy (>20% battery)"} 
                            value={healthyLocks.length}  
                            isLoadingStats={isLoading} 
                            isStatic={true} 
                        />
                        <Stats2
                            title={"Padlocks on active sites"}
                            value={locksOnActiveSites.length}  
                            isLoadingStats={isLoading} 
                            isStatic={true}   
                        />
                        <Stats2 
                            title={"Unlinked padlocks"} 
                            value={unlinkedLocks.length}  
                            isLoadingStats={isLoading} 
                            isStatic={true} 
                        />
                        <Stats2 
                            title={"Billable "} 
                            value={billableLocks.length}  
                            isLoadingStats={isLoading} 
                            isStatic={true} 
                        />
                        <Stats2 
                        title={"Non-billable"} 
                        value={nonBillableLocks.length}  
                        isLoadingStats={isLoading} 
                        isStatic={true} 
                    />
                    </div>
                    
                    <br></br>
                    {isLoading ? (
                        <div style={{ display: "flex", width: "100%" }}>
                            <DeviceLoadingGrid
                                CardCount={20}
                            />
                        </div>
                        ) : 
                        (
                            <PadlocksList 
                                locks={locks}
                                filtering={filtering}
                                update={update}
                                setUpdate={setUpdate}
                            />      
                        )
                    }
                    
                </div>
           
        </Await>
    );
}

export default Padlocks;

